import { useUser } from "@ip-contexts/user-context";
import { hasPermission } from "@ip-utils/permission";

type Props = {
  audience: string;
  scopes: string[];
  children: React.ReactNode;
};

export default function Protected({ audience, scopes, children }: Props) {
  const {
    state: { user },
  } = useUser();

  return <>{hasPermission(user, audience, scopes) && children}</>;
}
